import React, { useState, useEffect } from "react";
import { useNewOffer } from "../../../../context/new-offer";
import {
	ROUTE_HOME,
	ROUTE_PREFIX_EDIT_OFFER_MOBILE,
	ROUTE_PREFIX_CREATE_OFFER_MOBILE
} from "../../../../shared/constants";
import { css } from "emotion";
import { mobilePanel, painelContent, scrollMobile, mobilePanelHeader } from "./style";
import { withGetScreen } from "react-getscreen";
import { Panel, PanelHeader, PanelContent } from "../../../../../shared/create-offer/Panel";
import ArrowLeft from "../../../../../shared/atoms/ArrowLeft";
import StepFidelityProgram from "../StepFidelityProgram";
import {
	VinduloPendenteModal,
	AvisoProblemaModal,
	EditarNaoElegivel,
	EditarPerderBonus,
	AvisoProblemaModalPagamentoAntecipado,
	EditarNaoElegivelPagamentoAntecipado
} from "../../../../services/modals";

const NewOfferMobile = ({ edit, history }) => {
	const {
		programsFidelity,
		fetchBanksData,
		fetchDataUser,
		newOfferTempData,
		offerData,
		rankingData,
		setCurrentProgram,
		setOfferData,
		setRankingData,
		setNewOfferTempData,
		offersData,
		selectOfferToEdit,
		cleanNewOfferTempData,
		fetchOffersData,
		participantData,
		setSmilesDiamond
	} = useNewOffer();
	const [filteredCompanies, handleFilteredCompanies] = useState([]);
	const [modals, setModals] = useState({
		ofertaEmVenda: false,
		avisoProblemaModal: false,
		avisoNaoElegivelModal: false,
		avisoNaoElegivelModalPagamentoAntecipado: false,
		avisoProblemaModalPagamentoAntecipado: false
	});
	const [programToEdit, setProgramToEdit] = useState(undefined);

	// atualiza offers do context
	useEffect(() => {
		fetchOffersData();
	}, []);

	useEffect(() => {
		if (programsFidelity.data.length > 0) {
			handleFilteredCompanies(programsFidelity.data);
		}
	}, [programsFidelity.data]);

	useEffect(() => {
		setModals({
			...modals,
			vinculoPendente: participantData.isDone && participantData.hasRelationshipPendent
		});
	}, [participantData]);

	const cleanDataContext = () => {
		// Clean all data if it's a new offer
		cleanNewOfferTempData();
		selectOfferToEdit({});
		setRankingData({ ...rankingData, data: {} });
		setOfferData({
			...offerData,
			data: {
				price: 0,
				quant: 0,
				averageMiles: 0,
				reductions: 0
			}
		});
		setSmilesDiamond(undefined);
	};

	// Seleciona o programa de fidelidade e poem no stado para
	// passar para o componente de Dados de Registro
	const selectFidelityProgram = async (obj, ignoreModal) => {
		// Limpa store
		cleanDataContext();

		// Procura se ja existe oferta, se existir ele entra no fluxo edição
		if (offersData.data.offers && offersData.data.offers.length) {
			let offerFound = offersData.data.offers.find(
				offer => offer.fidelity.id === obj.id && offer.status > 0
			);
			if (
				offerFound &&
				offerFound.editable === false &&
				offerFound.type == 4 &&
				offerFound.status !== 4
			) {
				setModals({ ...modals, avisoProblemaModalPagamentoAntecipado: true });
				return;
			}
			// Verifica se é oferta inativa/problema
			else if (offerFound && offerFound.editable === false) {
				setModals({ ...modals, avisoProblemaModal: true });
				return;
			} else if (offerFound && (offerFound.type == 2 || !!offerFound.hasBonus) && !ignoreModal) {
				setProgramToEdit(obj);
				setModals({
					...modals,
					avisoNaoElegivelModal: offerFound.type == 2,
					avisoPerderBonusModal: !!offerFound.hasBonus
				});
				return;
			} else if (offerFound && (offerFound.type == 4 || !!offerFound.hasBonus) && !ignoreModal) {
				setProgramToEdit(obj);
				setModals({
					...modals,
					avisoNaoElegivelModalPagamentoAntecipado: offerFound.type == 4,
					avisoPerderBonusModal: !!offerFound.hasBonus
				});
				return;
			} else if (offerFound) {
				selectOfferToEdit(offerFound);
				history.push(ROUTE_PREFIX_EDIT_OFFER_MOBILE);
				return;
			}
		}

		setNewOfferTempData({ ...newOfferTempData, loyaltyData: obj });
		fetchDataUser(obj.id);
		fetchBanksData();
		setCurrentProgram(obj);
		history.push(ROUTE_PREFIX_CREATE_OFFER_MOBILE);
	};

	const confirmEdit = () => {
		setModals({
			...modals,
			avisoNaoElegivelModal: false,
			avisoNaoElegivelModalPagamentoAntecipado: false,
			avisoPerderBonusModal: false
		});
		selectFidelityProgram(programToEdit, true);
		setProgramToEdit(undefined);
	};

	const filterCompanies = val => {
		if (val.length > 0) {
			let companies = programsFidelity.data.filter(v => {
				return (
					v.acronym.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
					v.fidelityName.toLowerCase().indexOf(val.toLowerCase()) > -1
				);
			});

			handleFilteredCompanies(companies);
		} else {
			handleFilteredCompanies(programsFidelity.data);
		}
	};

	return (
		<div
			className={css`
				${mobilePanel};
			`}
		>
			<Panel>
				<PanelHeader
					className={css`
						${mobilePanelHeader}
					`}
				>
					<div className="go-back" onClick={() => history.push(ROUTE_HOME)}>
						<ArrowLeft>Voltar</ArrowLeft>
					</div>
				</PanelHeader>
				<PanelContent
					className={css`
						${painelContent};
					`}
				>
					<div
						className={css`
							${scrollMobile}
						`}
					>
						<StepFidelityProgram
							loading={programsFidelity.isFetching}
							companies={filteredCompanies}
							onChange={obj => selectFidelityProgram(obj)}
							filterCompanies={filterCompanies}
						/>
					</div>
				</PanelContent>
			</Panel>
			<VinduloPendenteModal
				show={modals.vinculoPendente}
				onConfirm={() => {
					setModals({ ...modals, vinculoPendente: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<AvisoProblemaModal
				show={modals.avisoProblemaModal}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModal: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<AvisoProblemaModalPagamentoAntecipado
				show={modals.avisoProblemaModalPagamentoAntecipado}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModalPagamentoAntecipado: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<EditarNaoElegivel
				show={modals.avisoNaoElegivelModal}
				onCancel={() => setModals({ ...modals, avisoNaoElegivelModal: false })}
				onConfirm={confirmEdit}
			/>
			<EditarNaoElegivelPagamentoAntecipado
				show={modals.avisoNaoElegivelModalPagamentoAntecipado}
				onCancel={() => setModals({ ...modals, avisoNaoElegivelModalPagamentoAntecipado: false })}
				onConfirm={confirmEdit}
			/>
			<EditarPerderBonus
				show={modals.avisoPerderBonusModal}
				onCancel={() => setModals({ ...modals, avisoPerderBonusModal: false })}
				onConfirm={confirmEdit}
			/>
		</div>
	);
};

export default withGetScreen(NewOfferMobile, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
